import styled, { css } from 'styled-components'
import { color } from '../styles'
import { InputContainer } from './InputContainer'

const ERROR = css`
  & .ant-picker.ant-picker-middle {
    border: 1px solid ${color.status.danger};
  }
  .ant-picker-suffix {
    color: ${color.status.danger};
  }
`

export const DatePickerContainer = styled(InputContainer)`
  width: auto;
  .ant-picker {
    padding: 8px 11px 8px;
    &:hover {
      border-color: rgba(var(--m-color-primary-60, 0, 84, 84), 1);
    }
  }
  .ant-picker-outlined {
    &:focus-within {
      box-shadow: none;
    }
  }
  .ant-picker-active-bar {
    background: rgba(var(--m-color-primary-60, 0, 84, 84), 1);
  }
`
